export const CLIENT_VERSION = '101';
//# sourceMappingURL=versions.js.map